import en from "./en";
import lo from "./lo";
const DICTS = { en, lo };
let currentLocale = "en";
const subs = new Set();
export function setLocale(l) {
    if (l === currentLocale)
        return;
    currentLocale = l;
    for (const cb of subs)
        cb(l);
}
export function getLocale() {
    return currentLocale;
}
/**
 * Subscribe to locale changes — used by app shells to force a re-render
 * when the user toggles the language. Returns an unsubscribe function.
 */
export function onLocaleChange(cb) {
    subs.add(cb);
    return () => { subs.delete(cb); };
}
export function t(key) {
    const dict = DICTS[currentLocale] ?? DICTS.en;
    const v = dict[key];
    if (v && v.length > 0)
        return v;
    return DICTS.en[key] ?? key;
}
//# sourceMappingURL=index.js.map